import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailRoutingModule } from "./detail-routing.module";
import { SharedModule } from "../../shared/shared.module";
import { CampaignDetailComponent } from './detail.component';

@NgModule({
  imports: [
    CommonModule,
    DetailRoutingModule,
    SharedModule
  ],
  declarations: [CampaignDetailComponent]
})
export class CampaignDetailModule { }



// WEBPACK FOOTER //
// ./src/app/components/detail/detail.module.ts